module.exports = "//static.jingzhuan.cn/soft-college/dist/prod/img/assets/images/new_hero-8636f9.png";